export default __webpack_public_path__ + "static/media/5-gm-achieved.9ed25cc8.svg";